import React from "react";
import { Card, CardBody, CardHeader } from "reactstrap";
import { useTranslation } from "react-i18next";
import {
  getTheme2MultiSelectCss,
  getTheme2SearchFilterFieldCss,
  getTheme2SearchFilterStatusFieldCss,
} from "utils/theme2MultiSelect";
import { getStickyStockTableStickyColumnCss } from "utils/reactTableTheme";

const SEARCH_DEALS_STATUS_PREFIX = "search-deals-status";

const SEARCH_DEALS_PAGE_STYLES = (isTheme2) => `
  ${isTheme2 ? `
  .search-deals.search-deals--theme2 .search-deals-table-card .card-body {
    padding: 15px;
    padding-top: 10px;
    padding-bottom: 0 !important;
  }
  ${getTheme2SearchFilterFieldCss({
    pageScopeSelector: ".search-deals.search-deals--theme2",
    filtersSelector: ".search-deals-table-card .search-deals-filters",
    rowClass: "search-deals-filters-row",
    colClass: "search-deals-filter-col",
  })}
  ${getTheme2SearchFilterStatusFieldCss({
    pageScopeSelector: ".search-deals.search-deals--theme2",
    filterColClass: "search-deals-filter-col",
    wideModifiers: ["status", "worksheet-type"],
    fieldWidth: "260px",
  })}
  .search-deals.search-deals--theme2 .search-deals-table-card .search-deals-filters {
    position: relative;
    z-index: 6;
    overflow-x: auto;
    overflow-y: hidden;
    max-width: 100%;
    padding-bottom: 4px;
    margin-bottom: 4px;
    -webkit-overflow-scrolling: touch;
    overscroll-behavior-x: contain;
  }
  /* Date Range: picker açıkken yatay scroll clip’ini kaldır; kapalıyken alanlar tablo header altında kalmasın */
  .search-deals.search-deals--theme2 .search-deals-table-card .search-deals-filters:has(.rdtOpen) {
    overflow: visible;
  }
  .search-deals.search-deals--theme2 .search-deals-table-card .search-deals-filters > form {
    margin-bottom: 0;
    width: max-content;
    min-width: 100%;
  }
  .search-deals.search-deals--theme2 .search-deals-filter-col--search .form-group {
    width: 280px !important;
    max-width: none !important;
  }
  .search-deals.search-deals--theme2 .search-deals-filter-col--date .form-group {
    width: 175px !important;
    max-width: none !important;
  }
  /* Date input yüksekliğini filtre Select’leriyle hizala (form-control taşması / header overlap) */
  .search-deals.search-deals--theme2 .search-deals-filter-col--date .rdt {
    width: 100%;
    line-height: 1;
  }
  .search-deals.search-deals--theme2 .search-deals-filter-col--date .rdt .form-control {
    height: 38px;
    min-height: 38px;
    box-sizing: border-box;
    padding-top: 0.375rem;
    padding-bottom: 0.375rem;
    line-height: 1.5;
  }
  .search-deals.search-deals--theme2 .search-deals-filter-col--date .rdtPicker {
    /* Tablo sticky header (z-index: 5) üstünde kalsın */
    z-index: 7 !important;
  }
  .search-deals.search-deals--theme2 .search-deals-filter-col--status .form-group,
  .search-deals.search-deals--theme2 .search-deals-filter-col--worksheet-type .form-group {
    max-width: none !important;
  }
  .search-deals.search-deals--theme2 .search-deals-filters-row {
    flex-wrap: nowrap !important;
    flex-direction: row !important;
    align-items: flex-end !important;
    column-gap: 4px;
    row-gap: 0;
    margin-left: 0 !important;
    margin-right: 0 !important;
    width: max-content;
    min-width: 100%;
  }
  .search-deals.search-deals--theme2 .search-deals-filter-col {
    padding-left: 4px;
    padding-right: 4px;
    flex: 0 0 auto !important;
    width: auto !important;
    max-width: none !important;
  }
  .search-deals.search-deals--theme2 .search-deals-filter-col .form-group {
    margin-bottom: 0.5rem;
  }
  @media (max-width: 575.98px) {
    .search-deals.search-deals--theme2 .search-deals-filter-col .form-group {
      width: auto !important;
      max-width: none !important;
    }
    .search-deals.search-deals--theme2 .search-deals-filter-col--search .form-group {
      width: 280px !important;
    }
    .search-deals.search-deals--theme2 .search-deals-filter-col--status .form-group,
    .search-deals.search-deals--theme2 .search-deals-filter-col--worksheet-type .form-group {
      width: 260px !important;
    }
    .search-deals.search-deals--theme2 .search-deals-filter-col--date .form-group {
      width: 175px !important;
    }
  }
  .search-deals.search-deals--theme2 .search-deals-filter-col:first-child {
    padding-left: 0;
  }
  ${getTheme2MultiSelectCss({
    prefix: SEARCH_DEALS_STATUS_PREFIX,
    pageScopeSelector: ".search-deals.search-deals--theme2",
  })}
  ${getTheme2MultiSelectCss({
    prefix: "search-deals-worksheet-type",
    pageScopeSelector: ".search-deals.search-deals--theme2",
  })}
  .search-deals.search-deals--theme2 .worksheet-container {
    border: 1px solid #D1D4DC !important;
  }
  ` : ""}
  .search-deals-card-header.card-header {
    padding-top: 2px;
    padding-bottom: 0;
  }
  .search-deals-card-header h2,
  .search-deals-card-header h4 {
    font-size: 16px !important;
    margin-top: 10px;
    margin-bottom: 0;
    line-height: 1.2;
  }
  .search-deals:not(.search-deals--theme2) .card .card-body {
    padding: 15px;
    padding-top: 10px;
    padding-bottom: 10px !important;
  }
  .sticky-stock-table .rt-table {
    width: 100%;
    min-width: 100%;
    border-collapse: collapse;
  }
  .sticky-stock-table .rt-thead .rt-th:not(:last-child) {
    text-align: center !important;
  }
  .sticky-stock-table .rt-thead .rt-th:last-child {
    text-align: right !important;
  }
  .sticky-stock-table .rt-thead .rt-th:not(:last-child) .rt-resizable-header-content {
    text-align: center;
    width: 100%;
    box-sizing: border-box;
  }
  .sticky-stock-table .rt-thead .rt-th:not(:last-child).-cursor-pointer .rt-resizable-header-content {
    padding-right: 2em;
  }
  .sticky-stock-table .rt-thead .rt-th:last-child .rt-resizable-header-content {
    text-align: right;
    width: 100%;
  }
  .sticky-stock-table .rt-tbody .rt-td:not(:last-child) {
    text-align: center;
    vertical-align: middle;
  }
  .sticky-stock-table .rt-tbody .rt-td:last-child {
    text-align: right;
    vertical-align: middle;
  }
  .sticky-stock-table .rt-tbody .rt-td:not(:last-child) > * {
    max-width: 100%;
    min-width: 0;
  }
  ${getStickyStockTableStickyColumnCss()}
  .search-deals .inventory-table-wrap {
    min-width: 0;
    max-width: 100%;
  }
  @media (max-width: 991.98px) {
    .search-deals .inventory-table-wrap {
      overflow-x: auto;
      -webkit-overflow-scrolling: touch;
      overscroll-behavior-x: contain;
    }
    .search-deals .inventory-table-wrap .table-scroll-wrapper {
      overflow-x: auto !important;
      -webkit-overflow-scrolling: touch;
    }
    .search-deals.search-deals--theme2 .search-deals-table-card .card-body {
      overflow-x: hidden;
    }
  }
`;

const SearchDealsCards = ({ isTheme2, filters, table, tableHeader, title }) => {
  const { t } = useTranslation();
  const pageTitle = title ?? t("searchDeals.title");

  const titleHeader = (
    <CardHeader className="search-deals-card-header">
      <h2 className="mb-0">{pageTitle}</h2>
    </CardHeader>
  );

  return (
    <>
      <style>{SEARCH_DEALS_PAGE_STYLES(isTheme2)}</style>
      {isTheme2 ? (
        <Card className="search-deals-table-card">
          {titleHeader}
          <CardBody>
            <div className="search-deals-filters">{filters}</div>
            {table}
          </CardBody>
        </Card>
      ) : (
        <>
          <Card>
            {titleHeader}
            <CardBody>{filters}</CardBody>
          </Card>
          <Card className="mt-2">
            {tableHeader ? <CardHeader>{tableHeader}</CardHeader> : null}
            <CardBody>{table}</CardBody>
          </Card>
        </>
      )}
    </>
  );
};

export default SearchDealsCards;
